import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import useActionsFilteredAlertsMessages from '@/components/AlertsMessages/composables/useActionsFilteredAlertsMessages'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import {
  AlertMessage,
  AlertMessageVisibility,
  AlertsMessageToggleVisibility,
  AlertsMessageVisibilityIcons
} from '@/store/modules/alertsMessages/alertsMessagesTypes'
import useDialog from '@/composables/useDialog'
import useFeedback from '@/composables/useFeedback'
import { DialogTypes } from '@/store/modules/dialog/dialogTypes'
import { ComponentWhereIsRendered } from '@/store/modules/alerts/alertsTypes'
import { dateFormat } from '@/helpers/dateTime'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsMessagesListItemComponent',
  props: {
  alert: {
    type: Object as PropType<AlertMessage>,
    required: true
  }
},
  setup(__props) {

const props = __props;



// COMPOSABLE
const { changeVisibility, goToAlertsMessagesURL } = useActionsFilteredAlertsMessages()
const { getDialogSuccess, getDialogError, getDialog } = useDialog()
const { showFeedbackSuccess } = useFeedback()

// TRANSLATIONS
const { t } = useI18n()
const texts = {
  alerts: t('navigation.alerts_menu.alerts'),
  changeVisibilityError: t('navigation.alerts_menu.change_visibility_error'),
  chronologicalOrder: t('navigation.alerts_menu.chronological_order'),
  expirationOrder: t('navigation.alerts_menu.expiration_order'),
  link: t('navigation.alerts_menu.no_data.link'),
  loadError: t('navigation.alerts_menu.load_error'),
  noData: t('navigation.alerts_menu.no_data.text'),
  noRead: t('navigation.alerts_menu.no_read'),
  notificationDate: t('navigation.alerts_menu.notification_date'),
  notificationRead: t('components.alerts.notification_read'),
  notificationUnread: t('components.alerts.notification_unread'),
  read: t('navigation.alerts_menu.read'),
  realized: t('navigation.alerts_menu.realized'),
  viewMoreAlerts: t('navigation.alerts_menu.more_alerts')
}

const expiredDate = computed(() => {
  const date = dateFormat(props.alert.expireAt, 'DD/MM/yyyy')
  return t('navigation.alerts_menu.expired_date', { date }).toString()
})

// COMPUTED
const isNotReadAlert = computed(() => props.alert.visibility === AlertMessageVisibility.NO_READ)

// METHODS
function goToAlert(alert: AlertMessage) {
  goToAlertsMessagesURL(alert)
}

function showFeedbackText(alertVisibility: AlertMessageVisibility) {
  const feeedbackText =
    alertVisibility === AlertMessageVisibility.NO_READ ? texts.notificationUnread : texts.notificationRead
  showFeedbackSuccess({
    message: feeedbackText as string,
    componentWhereIsRendered: ComponentWhereIsRendered.LF_HEADER_TITLE
  })
}

async function onClickToggleRead(alertMessage: AlertMessage) {
  try {
    if (alertMessage.visibility === AlertMessageVisibility.NO_READ) {
      alertMessage.visibility = AlertMessageVisibility.READ
    } else {
      alertMessage.visibility = AlertMessageVisibility.NO_READ
    }
    await changeVisibility(alertMessage)
    showFeedbackText(alertMessage.visibility)
  } catch (error) {
    getDialogError({ message: texts.changeVisibilityError as string })
    alertMessage.visibility = AlertsMessageToggleVisibility[alertMessage.visibility]
  }
}

async function onClickDone(alertMessage: AlertMessage) {
  getDialog({
    type: DialogTypes.INFO,
    message: t('components.dialog.alert_message_done_prompt', { message: alertMessage.message }).toString(),
    action: () => doneAlert(alertMessage)
  })
}

async function doneAlert(alertMessage: AlertMessage) {
  try {
    alertMessage.visibility = AlertMessageVisibility.DONE
    await changeVisibility(alertMessage)
    getDialogSuccess({
      message: t('components.dialog.alert_message_done_success', { message: alertMessage.message }).toString()
    })
  } catch (error) {
    getDialogError({ message: texts.changeVisibilityError as string })
  }
}


return { __sfc: true,props, changeVisibility, goToAlertsMessagesURL, getDialogSuccess, getDialogError, getDialog, showFeedbackSuccess, t, texts, expiredDate, isNotReadAlert, goToAlert, showFeedbackText, onClickToggleRead, onClickDone, doneAlert, Icons, LexonTooltipComponent, AlertsMessageVisibilityIcons }
}

})